/* Arte Líquida — «Combina com a sua escolha» na gaveta do carrinho.
   O elemento <al-sugestoes> vive dentro de #CartDrawer, que o Origin volta a
   renderizar a cada alteração; por isso carrega sempre em connectedCallback. */
(function () {
  if (customElements.get('al-sugestoes')) return;

  class AlSugestoes extends HTMLElement {
    connectedCallback() {
      this.max = parseInt(this.dataset.max || '3', 10);
      this.cartIds = (this.dataset.cartIds || '').split(',').filter(Boolean);
      this.lista = this.querySelector('[data-al-sug-corpo]');
      this.hidden = true;
      if (!this.dataset.productId || !this.dataset.url) return;
      this.carregar('complementary')
        .then((n) => (n ? n : this.carregar('related')))
        .catch(() => {});
    }

    carregar(intent) {
      const url = `${this.dataset.url}?product_id=${encodeURIComponent(this.dataset.productId)}&limit=8&intent=${intent}&section_id=al-carrinho-sugestoes`;
      return fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          if (!html) return 0;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const itens = Array.from(doc.querySelectorAll('.al-sug__item')).filter(
            (el) => this.cartIds.indexOf(el.dataset.productId) === -1
          ).slice(0, this.max);
          if (!itens.length) return 0;
          this.lista.replaceChildren(...itens);
          this.hidden = false;
          this.lista.querySelectorAll('button[data-variant-id]').forEach((b) =>
            b.addEventListener('click', () => this.adicionar(b))
          );
          return itens.length;
        });
    }

    adicionar(botao) {
      if (botao.disabled) return;
      botao.disabled = true;
      botao.classList.add('is-loading');
      fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(botao.dataset.variantId), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      })
        .then((r) => r.json())
        .then((estado) => {
          if (estado.status) throw new Error(estado.description || 'erro');
          const gaveta = document.querySelector('cart-drawer');
          const item = estado.items ? estado.items[0] : estado;
          if (gaveta && estado.sections) {
            gaveta.renderContents({ id: item.id, sections: estado.sections });
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => {
          botao.disabled = false;
          botao.classList.remove('is-loading');
        });
    }
  }

  customElements.define('al-sugestoes', AlSugestoes);
})();
